<div class="buildings-container">
  <div class="header">
    <label><img src="./assets/images/fh/buildings/build.svg" /><span [ghs-label]="'party.campaign.sheet.buildings'"></span></label>
    <input
      type="text"
      #building
      [ghs-label]="'party.campaign.sheet.buildings.unlock'"
      [ghs-label-attribute]="'placeholder'"
      (keydown.enter)="unlockBuilding(building)"
    />
    <img src="./assets/images/plus.svg" (click)="unlockBuilding(building)" />
  </div>
  <ghs-buildings-list [buildings]="buildings" (changed)="updateBuildings()"></ghs-buildings-list>
</div>
